/**
 * @enum {number}
 */
var PathType = {
    POINT: 0,
    LINE: 1,
    CURVEC: 2,
    CLOSE: 3,
    ARC: 4
};

module.exports = PathType;

